export const imageEntities = {
  worker: 'poltrona',
  salon: 'salone',
  service: 'servizio',
  clients: 'clienti',
  icons: 'icone',
};

const BUST_STORAGE_KEY = 'zb_img_bust';

let bustMemoryCache = null;

const readBustMap = () => {
  if (bustMemoryCache) return bustMemoryCache;
  try {
    bustMemoryCache = JSON.parse(localStorage.getItem(BUST_STORAGE_KEY) || '{}') || {};
  } catch (_) {
    bustMemoryCache = {};
  }
  return bustMemoryCache;
};

const bustKey = (entity, id, type) =>
  type ? `${entity}:${id}:${type}` : `${entity}:${id}`;

/** Invalida la cache browser per un'immagine dopo upload (URL altrimenti identico). */
export const bumpIconCache = (entity, id, type) => {
  if (!entity || !id) return;
  try {
    const map = { ...readBustMap() };
    map[bustKey(entity, id, type)] = Date.now();
    bustMemoryCache = map;
    localStorage.setItem(BUST_STORAGE_KEY, JSON.stringify(map));
  } catch (_) {
    // ignore quota / private mode
  }
};

const getBustQuery = (entity, id, type) => {
  const version = readBustMap()[bustKey(entity, id, type)];
  return version ? `&v=${version}` : '';
};

export const getIconUrl = (id, entity, type) => {
  if (!id || !entity) return '';
  const baseUrl = (process.env.REACT_APP_API_URL || '') + 'img/';
  const bust = getBustQuery(entity, id, type);
  switch (entity) {
    case imageEntities.service:
      return `${baseUrl}${entity}?id=${id}${bust}`;
    case imageEntities.icons:
      return `${baseUrl}${entity}?id=${id}${bust}`;
    case imageEntities.worker:
      return `${baseUrl}${entity}?id=${id}${bust}`;
    case imageEntities.clients:
      return `${baseUrl}${entity}?id=${id}${bust}`;
    case imageEntities.salon:
      return `${baseUrl}${entity}?id=${id}&tipo=${type}${bust}`;
    default:
      return '';
  }
};
